import { render, staticRenderFns } from "./environmentalReportForm.vue?vue&type=template&id=81d3176a"
import script from "./environmentalReportForm.vue?vue&type=script&lang=js"
export * from "./environmentalReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports